import { Route, Switch, Redirect } from "react-router-dom";

import Setting from "./mypage/Setting";
import Credit from "./mypage/Credit";
import Payouts from "./mypage/Payouts";
import PayoutList from "./mypage/PayoutList";
import MyPackage from "./mypage/MyPackage";
import ReviewedPkgList from "./mypage/ReviewedPkgList";

export default function Mypage(){
  return (
    <div style={{height: 'inherit'}}>
      <Switch>
        <Route path="/mypage/setting" component={Setting} /> 
        <Route path="/mypage/remittance-info" component={Credit} /> 
        <Route path="/mypage/remittance-request" component={Payouts} /> 
        <Route path="/mypage/payoutList" component={PayoutList} /> 
        <Route path="/mypage/mypackage" component={MyPackage} /> 
        <Route path="/mypage/packages-of-reviewed" component={ReviewedPkgList} /> 
        <Redirect to="/mypage/setting" from="/mypage"/> 
      </Switch>
    </div>
  );
}
